import { GetServerSideProps } from 'next';
import { PreRenderProps } from '@/pages/_app';
import Flyer from '@/components/flyer/index';
import NonSduiComponent from '@/components/non-sdui/non-sdui.component';
import { getFlyerViewDefinition } from '@/ssr/view-definition-flyer-page-query';
import { useIntl } from 'react-intl';
import { isPharmaprixBanner } from '@/utils';
import { withTokenRefresh } from '@/utils/ssr-utils';
import { HOST } from '@/data/constants';

// @ts-ignore
export const getServerSideProps: GetServerSideProps<PreRenderProps> = withTokenRefresh(async (context) => {
  const data = await getFlyerViewDefinition(context);

  return { props: data };
});

const FlyerRoutes = (props: any) => {
  const { formatMessage } = useIntl();
  const isPharmaprix = isPharmaprixBanner();
  const currentUrlBase = isPharmaprix ? HOST.PHX_HOME : HOST.SDM_HOME;

  const constructFlyerMetaData = (data: any) => {
    const { isError, isStoreCodeNotApplied, viewDefinition } = data || {};
    const bannerName = isPharmaprix ? 'Pharmaprix' : 'Shoppers Drug Mart';
    let title, description;
    if (isError || isStoreCodeNotApplied) {
      title = formatMessage({ id: 'simpleFlyerSeoTitle' }, { bannerName });
      description = formatMessage({ id: 'simpleFlyerSeoDescription' }, { bannerName });
    } else {
      const { city: cityName, name: locationName, address, province, postal_code } = viewDefinition || {};
      const locationAddress = `${address}, ${cityName} ${province} ${postal_code}`;
      title = formatMessage({ id: 'flyerSeoTitle' }, { bannerName, locationName, cityName });
      description = formatMessage({ id: 'flyerSeoDescription' }, { bannerName, locationAddress });
    }

    return {
      title,
      description,
      addMetaNoRobots: false,
      canonicalUrlSlug: 'flyer',
      jsonLd: null,
    };
  };

  const seoMetaData = constructFlyerMetaData(props);
  const seoWrapperData = {
    seoMetaData,
    currentUrlBase,
    jsonLdScript: '',
  };

  return (
    <NonSduiComponent {...seoWrapperData}>
      <Flyer />
    </NonSduiComponent>
  );
};

export default FlyerRoutes;
